import type { MouseEventHandler } from 'react';
import styles from './Overlay.module.css';

/**
 * Figma: `Overlay` (2024:31101 → `Type=Default`, 2024:31102) — the scrim behind
 * `Modal` and `Drawer`. A tint of `component/overlay/surface` over a
 * uniform `background-blur/xxs` (6) backdrop blur, filling whatever it is
 * placed in.
 *
 * `Type` is a one-option axis, so it does not become a prop.
 *
 * Absolutely positioned: put it inside a positioned container and it covers
 * that container. `Modal` and `Drawer` put it inside their `<dialog>`, which
 * covers the viewport, so there it covers the viewport too.
 *
 * Purely decorative — hidden from assistive tech. A click on it is how a
 * pointer user dismisses a dialog, which `onClick` exists for; the keyboard
 * equivalent is Escape, which the dialog owns.
 */
export type OverlayProps = {
  onClick?: MouseEventHandler<HTMLDivElement>;
  className?: string;
};

export function Overlay({ onClick, className }: OverlayProps) {
  return (
    <div
      className={className ? `${styles.overlay} ${className}` : styles.overlay}
      aria-hidden="true"
      onClick={onClick}
    />
  );
}
